module.exports = __webpack_public_path__ + "static/media/Swoosh-Logo.e1459a98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Swoosh-Logo.svg
// module id = 975
// module chunks = 0